import styled from "styled-components"

const Title = styled.div `
    width: 100%;
    height: 35px;

    margin-bottom: 10%;

    h1{
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        line-height: 50px;
        letter-spacing: 0em;
        text-align: left;
        color: #D4CFCC;
    }
`

export default Title